import { render, staticRenderFns } from "./SelectVipCustomerModal.vue?vue&type=template&id=6a3ade76&"
import script from "./SelectVipCustomerModal.vue?vue&type=script&lang=js&"
export * from "./SelectVipCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports